import { useEffect } from "react";

// The selection of a recipient picker dialog (users, roles or cohorts).
//
// The selection belongs to the dialog, not to the page of rows it shows: it
// starts once, when the dialog opens, from the recipients already chosen
// (preSelectedIds), keeping every one of them even when it is not on the
// page shown (only its id is known then, which is all a save sends). A
// search or another page never rewrites it, and ticking rows changes only
// the rows shown. The dialogs used to reset it to "the preselected rows on
// this page" whenever the rows changed, so a search dropped every chosen
// recipient it did not show (F-BUG-5).
//
// Returns the onSelectionChange handler for the dialog's list.
// The recipients for a list of ids: the row of each id when it is among
// the rows loaded, otherwise just its id (all a save sends), so a recipient
// who is not on the page loaded is never dropped.
export const toRecipients = (ids, rows = []) =>
  (ids || []).map((id) => rows.find((row) => row.id === id) || { id });

const useRecipientSelection = ({
  rows = [],
  preSelectedIds = [],
  selected = [],
  setSelected,
}) => {
  useEffect(() => {
    setSelected(toRecipients(preSelectedIds, rows));
    // Once per opening: the dialogs mount when they open.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (event) => {
    // The list calls this with the event of a row tick, or with the rows of
    // a "select all" on the page.
    const value = (Array.isArray(event) ? event : event?.value) || [];
    const shown = new Set(rows.map((row) => row.id));
    setSelected([
      ...(selected || []).filter((item) => !shown.has(item.id)),
      ...value.filter((item) => shown.has(item.id)),
    ]);
  };
};

export default useRecipientSelection;
